import { fontCss, mobileFontCss } from 'common/utils/styleUtilsNew'
import styled, { css } from 'styled-components'
import { StrictRequired } from 'src/shared/types/typescript-utils/strict-required'
import { ColorEntityInterface } from 'src/shared/schemas/color.schema'
import { FontEntityInterface } from 'src/shared/schemas/font.schema'

type FaqItemTitleUiProps = StrictRequired<
  ColorEntityInterface & FontEntityInterface
> & {
  expanded: boolean
}

const FaqItemTitleUi = styled.div<FaqItemTitleUiProps>`
  ${p =>
    p.expanded &&
    css`
      margin-bottom: 5px;
    `}
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${fontCss}
  cursor: pointer;
  ${p => p.theme.phone} {
    ${mobileFontCss}
  }
  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      ${mobileFontCss}
    `}
`

export default FaqItemTitleUi
